import useSWR, { SWRConfiguration, Fetcher } from 'swr';
import {
  useQueryParam, NumberParam, StringParam,
  BooleanParam,
} from 'use-query-params';

import { IndexPayload } from 'types/request';
import * as BroadcastFormApi from 'api/BroadcastFormAPI';
import { IBroadcastFormsPayload } from 'types/BroadcastForm';
import React from 'react';
import { ISearchQuery } from 'components/Inputs/IndexFilter_Id_Name';

export const useBroadcastFormsQuery = (
  options: SWRConfiguration<
  IndexPayload<IBroadcastFormsPayload>, any, Fetcher<IndexPayload<IBroadcastFormsPayload>> | undefined
  > = {},
) => {
  const [pageParam = 1] = useQueryParam('page', NumberParam);
  const [perPageParam = 10] = useQueryParam('perpage', NumberParam);
  const [sortFieldParam] = useQueryParam('sortField', StringParam);
  const [sortDirectionParam] = useQueryParam('sortDirection', StringParam);
  const [searchQueryParam] = useQueryParam('searchQuery', StringParam);
  const [statusTypeParam] = useQueryParam('statusType', StringParam);
  const [includeEnterpriseSurveysParam] = useQueryParam('includeEnterpriseSurveys', BooleanParam);

  const searchQuery = React.useMemo((): ISearchQuery => {
    if (!searchQueryParam) {
      return {};
    }
    const [searchField, searchValue] = searchQueryParam.split(',');
    return { searchField, searchValue }
  }, [searchQueryParam]);

  const trimmedSearchValue = searchQuery.searchValue?.trim();
  return useSWR<IndexPayload<IBroadcastFormsPayload>>([
    'broadcast-forms',
    pageParam,
    perPageParam,
    (searchQuery.searchField && trimmedSearchValue) ? searchQuery.searchField : undefined,
    (searchQuery.searchField && trimmedSearchValue) ? trimmedSearchValue : undefined,
    (sortFieldParam && sortDirectionParam) ? sortFieldParam : undefined,
    (sortFieldParam && sortDirectionParam) ? sortDirectionParam : undefined,
    statusTypeParam,
    includeEnterpriseSurveysParam,
  ], ([
    ,
    page,
    perpage,
    searchField,
    searchValue,
    sortField,
    sortDirection,
    statusType,
    includeEnterpriseSurveys,
  ]) => BroadcastFormApi.getForms({
    page,
    perpage,
    searchField,
    searchValue,
    sortField,
    sortDirection,
    statusType,
    includeEnterpriseSurveys,
  }), options)
}
